import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authContext } from "configs/context/authContext";

// --- Menu config ---
const listMenu = [
  // { id: 0, title: "Home", to: "/home", icon: "nav-icon fas fa-home" },
  // { id: 1, title: "Office", to: "/office", icon: "nav-icon fas fa-city" },
  // {
  //   id: 2,
  //   title: "Partner",
  //   to: "/partnership",
  //   icon: "nav-icon fas fa-handshake",
  // },
  // { id: 3, title: "Document", to: "/document", icon: "nav-icon fas fa-file" },
];

function Sidebar() {
  const navigate = useNavigate();
  const { user, handleLogoutUser } = useContext(authContext);

  const [activeTab, setActiveTab] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 993);

  // handle resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 993);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavClick = (menuItem) => {
    setActiveTab(menuItem.title);
    navigate(menuItem.to);
  };

  return (
    <aside className="main-sidebar sidebar-light-primary elevation-4">
      {/* Brand Logo */}
      <a href="/" className="brand-link d-flex" style={{ gap: "0.5rem" }}>
        <img
          className="logo-lg"
          src="/img/logo/benderakuWithText.svg"
          alt="logo"
          width={200}
          height={30}
          style={{ marginLeft: "10px", opacity: 0.8, objectFit: "contain" }}
        />
        <img
          className="logo-mini mx-auto"
          src="/img/logo/benderaku-mini.png"
          alt="logo-mini"
          width={30}
          height={30}
          style={{
            opacity: 0.8,
          }}
        />
      </a>

      {/* Sidebar */}
      <div className="sidebar d-flex flex-column">
        {/* User Panel */}
        <div
          style={{ cursor: "pointer" }}
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
          className="user-panel py-4 d-flex align-items-center"
        >
          <div className="image">
            <img
              src="/img/logo/person-icon.png"
              className="img-circle elevation-2"
              alt="User"
            />
          </div>
          <div className="info user">
            <p className="m-0 p-0 text-wrap text-break text-left nav-link">
              {user?.username ?? "User"}
            </p>
          </div>
        </div>

        {/* Menu */}
        <nav className="mt-2 mb-4">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            role="menu"
            data-accordion="false"
          >
            {listMenu.map((menuItem) => (
              <li
                key={menuItem.id}
                className={`nav-item navbars rounded ${
                  activeTab === menuItem.title ? "primary-bg" : ""
                }`}
              >
                <Link
                  to={menuItem.to}
                  onClick={() => handleNavClick(menuItem)}
                  className={`nav-link ${
                    activeTab === menuItem.title
                      ? "text-white"
                      : "primary-color"
                  }`}
                >
                  <i className={menuItem.icon} />
                  <p>{menuItem.title}</p>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        {/* Logout only on mobile */}

        <div className=" d-sm-none d-block nav-item d-flex w-100 mt-auto primary-bg mb-2 rounded">
          <button
            onClick={handleLogoutUser}
            className="nav-link btn btn-link p-0 text-white"
          >
            <i className="fas fa-sign-out-alt mr-1" />
            Logout
          </button>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
